// @ts-nocheck
import React, { useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { useDifusiones } from '../../context/DifusionesContext';
import { useBody } from '../../../Body/state/BodyContext';
import { Box, Button, Modal, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import SaveIcon from '@mui/icons-material/Save';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const MAX_LENGTH = 600;

const ConfirmRoot = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    boxShadow: 24,
    padding: '25px',
    width: 420,
    [theme.breakpoints.down('sm')]: {
        width: '85%',
    },
}));

export default function DrafterFirma({ firma, onClose, fetchFirmas }) {
    const { actualizarFirma } = useDifusiones();
    const { setMessage, setSuccess } = useBody();
    const editorRef = useRef(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [charCount, setCharCount] = useState(firma.firmaHtml?.length ?? 0);
    const [error, setError] = useState('');

    const getContenido = () => editorRef.current?.getContent() ?? "";

    const handleEditorChange = (content) => {
        setCharCount(content.length);
        if (error) setError('');
    };

    const validar = () => {
        const contenido = getContenido();
        if (!contenido.trim()) {
            setError('La firma no puede quedar vacía.');
            return false;
        }
        if (contenido.length > MAX_LENGTH) {
            setError(`La firma no puede superar los ${MAX_LENGTH} caracteres.`);
            return false;
        }
        return true;
    };

    const handleGuardar = () => {
        if (validar()) setConfirmOpen(true);
    };

    const handleConfirm = async () => {
        setConfirmOpen(false);
        const contenido = getContenido();
        const nuevaFirma = {
            ...firma,
            firmaHtml: contenido.includes("simple-translate") ? firma.firmaHtml : contenido,
        };

        try {
            const response = await actualizarFirma([nuevaFirma]);
            if (response?.severity === "error") {
                setError(response.status);
                return;
            }
            setSuccess("Firma modificada con éxito");
            onClose();
            await fetchFirmas();
        } catch (error) {
            console.error("Error al actualizar firma:", error);
            setMessage("Hubo un error al actualizar las firmas");
        }
    };

    return (
        <>
            <Box sx={{ border: '1px solid', borderColor: error ? 'error.main' : 'divider', borderRadius: 1, overflow: 'hidden', mb: 0.5 }}>
                <Editor
                    onInit={(evt, editor) => (editorRef.current = editor)}
                    initialValue={firma.firmaHtml}
                    apiKey="xy3697hjbr5tawky3q6ud2123d7btx79etod92u0hf1yyft4"
                    onEditorChange={handleEditorChange}
                    init={{
                        height: 220,
                        menubar: false,
                        content_style: 'body { font-family: Helvetica, Arial, sans-serif; font-size: 14px; }',
                    }}
                />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="caption" color={error ? 'error' : 'text.secondary'}>
                    {error}
                </Typography>
                <Typography variant="caption" color={charCount > MAX_LENGTH ? 'error' : 'text.secondary'}>
                    {charCount}/{MAX_LENGTH}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={onClose}>
                    Cancelar
                </Button>
                <Button
                    sx={{ textTransform: 'none' }}
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    onClick={handleGuardar}
                >
                    Guardar
                </Button>
            </Box>

            <Modal open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                <ConfirmRoot>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <WarningAmberIcon color="primary" />
                            <Typography variant="h6">Confirmar cambio de firma</Typography>
                        </Box>
                        <Typography variant="body1" color="text.secondary">
                            Este cambio <strong>afectará a todos los usuarios del alias</strong>.
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                            <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={() => setConfirmOpen(false)}>
                                Cancelar
                            </Button>
                            <Button sx={{ textTransform: 'none' }} variant="contained" color="primary" onClick={handleConfirm}>
                                Confirmar
                            </Button>
                        </Box>
                    </Box>
                </ConfirmRoot>
            </Modal>
        </>
    );
}
